import React, { Component } from 'react'
import moment from 'moment';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import Authentication from '../../session';
import { getBranchesLatest } from '../../store/actions';
import { connect } from 'react-redux';
import withRouter from '../lib/withRouter';
import { BasicLazyParams } from '../../utile';
import Service from '../../services';
import { paymentModes } from '../../constants';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { baseUrlAdmin } from '../../store/apiConstants';
import LoadingComponent from '../loadingComponent';
import { Toast } from 'primereact/toast';
import { DownloadIcon } from '../svgIcons';
import BulkFeeReciepts from '../financeManagement/bulkFeeReciepts';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import ClassetCalendar from '../../classetComponents/classetCalender';
import * as XLSX from 'xlsx';
const dateRangeOptions = [
  { value: 1, label: "Today" },
  { value: 2, label: "Yesterday" },
  { value: 3, label: "This Week" },
  { value: 4, label: "Last Week" },
  { value: 5, label: "This Month" },
  { value: 6, label: "Last 3 Months" },
  { value: 7, label: "Academic Session" },
  { value: 8, label: "Custom" },
]

class FeeCollectionReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      totalRecords: 0,
      lazyParams: BasicLazyParams,
      feeCollectionReport: [],
      branchId: null,
      paymentMode: null,
      dateRangeType: null,
      startDate: null,
      endDate: null,
    };
    this.service = new Service();
  }

  async componentDidMount() {
    this.props.getBranchesLatest(true);
    await this.getFeeCollectionReportInfo();
  }

  // Filter branches based on user assignments
  getFilteredBranches = () => {
    const { userInfo, branchData } = this.props;

    // Admin bypass - show all branches
    if (userInfo?.isAdmin === true) {
      return branchData || [];
    }

    // If no assigned branches, show all
    if (!userInfo?.branchs || userInfo.branchs.length === 0) {
      return branchData || [];
    }

    // Filter by assigned branches
    const filtered = branchData?.filter(branch =>
      userInfo.branchs.includes(branch.key)
    ) || [];

    return filtered;
  }

  onPage = (event) => {
    this.setState((prevState) => ({
      lazyParams: {
        ...prevState.lazyParams,
        ...event
      }
    }), () => this.getFeeCollectionReportInfo());
  };

  getDateRange = () => {
    const { dateRangeType, startDate, endDate } = this.state;
    if (!dateRangeType) return {};
    const today = moment();
    let start, end;
    switch (dateRangeType) {
      case 1: start = today.clone().startOf('day'); end = today.clone().endOf('day'); break;
      case 2: start = today.clone().subtract(1, 'day').startOf('day'); end = today.clone().subtract(1, 'day').endOf('day'); break;
      case 3: start = today.clone().startOf('week'); end = today.clone().endOf('week'); break;
      case 4: start = today.clone().subtract(1, 'week').startOf('week'); end = today.clone().subtract(1, 'week').endOf('week'); break;
      case 5: start = today.clone().startOf('month'); end = today.clone().endOf('month'); break;
      case 6: start = today.clone().subtract(3, 'months'); end = today.clone().endOf('day'); break;
      case 7: break;
      case 8:
        if (startDate && endDate) {
          start = moment(startDate).startOf('day');
          end = moment(endDate).endOf('day');
        }
        break;
      default: break;
    }
    if (start && end) return { startDate: start.toISOString(), endDate: end.toISOString() };
    return {};
  }

  async getFeeCollectionReportInfo() {
    const { lazyParams, branchId, paymentMode } = this.state;
    this.setState({ isLoading: true });

    const page = Math.floor((lazyParams.first || 0) / lazyParams.rows) + 1;
    const dateRange = this.getDateRange();

    const payload = {
      academicYear: localStorage.getItem('userAcademicYear'),
      page,
      limit: lazyParams.rows,
      ...(branchId && { branchId }),
      ...(paymentMode && paymentMode.length > 0 && { paymentMode }),
      ...dateRange,
    };

    let fullData = await this.service.post(`${baseUrlAdmin}/financeReports/feeCollectReport`, payload, true);

    if (fullData.status && fullData?.res?.status) {
      this.setState({
        feeCollectionReport: fullData?.res?.data,
        totalRecords: fullData?.res?.totalRecords,
        isLoading: false,
      });
    } else {
      this.setState({ isLoading: false });
    }
  }

  applyFilters = () => {
    this.setState((prevState) => ({
      lazyParams: { ...prevState.lazyParams, first: 0 }
    }), () => this.getFeeCollectionReportInfo());
  };

  downloadExcelReport = async () => {
    this.setState({ isLoading: true });
    const dateRange = this.getDateRange();
    const { branchId, paymentMode } = this.state;

    const payload = {
      academicYear: localStorage.getItem('userAcademicYear'),
      download: true,
      ...(branchId && { branchId }),
      ...(paymentMode && paymentMode.length > 0 && { paymentMode }),
      ...dateRange,
    };

    let fullData = await this.service.post(`${baseUrlAdmin}/financeReports/feeCollectReport`, payload, true);
    this.setState({ isLoading: false });

    const dataToExport = fullData?.res?.data || [];
    if (dataToExport.length === 0) {
      this.toast?.show({ severity: 'warn', summary: 'No Data', detail: 'No records to export', life: 3000 });
      return;
    }

    const excelData = dataToExport.map(item => ({
      'Student Id': item.username?.slice(3) || '',
      'Student Name': `${item.firstName || ''} ${item.lastName || ''}`,
      'Class-Section': `${item.studentClassName || item.className || ''}-${item.sectionName || ''}`,
      'Receipt No': item.receiptNo,
      'Fee Paid': item.feePaidDetails?.amountPaying || 0,
      'Fee Type': item.feePaidDetails?.feeType || '',
      'Payment Mode': item.paymentMode,
      'Paid Date': item.receiptDate ? moment(item.receiptDate).format('DD/MM/YYYY') : '-'
    }));

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Fee Collection Report');
    const fileName = `FeeCollectionReport_${moment().format('DDMMYYYY')}.xlsx`;
    XLSX.writeFile(wb, fileName);
  };

  render() {
    const filteredBranches = this.getFilteredBranches();

    return (
      <>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: '0',
          marginLeft: "100px",
          marginTop: "55px",
          overflow: 'auto',

        }}>
          <div className="card filters-card mt-1 pt-0">
            <div className="flex">
              <div className="col-4">
                <p className="add-vehicle-field-label">
                  Branch
                </p>
                <div className="flex justify-content-start  align-items-center">
                  <ClassetDropdown
                    optionLabel="name"
                    optionValue="key"
                    value={this.state.branchId}
                    options={filteredBranches}
                    onChange={(e) => this.setState({ branchId: e.target.value }, this.applyFilters)}
                    width={"25vw"}
                    height={"48px"}
                    placeholder={
                      <div className="flex justify-content-start  align-items-center">
                        <span className="">Select Branch</span>
                      </div>
                    }
                  />
                </div>
              </div>
              <div className="col-4">
                <label className="add-vehicle-field-label">
                  Payment Mode
                </label>
                <div className="flex justify-content-start  align-items-center">
                  <ClassetMultiSelect
                    id="paymentMode"
                    width={"25vw"}
                    height={"48px"}
                    options={paymentModes}
                    value={this.state.paymentMode}
                    onChange={(e) => this.setState({ paymentMode: e.target.value }, this.applyFilters)}
                    placeholder={
                      <div className="flex justify-content-start  align-items-center">
                        <span className="">Select Mode</span>
                      </div>
                    }
                  />
                </div>
              </div>
              <div className="col-4">
                <label className="add-vehicle-field-label">Date Range</label>
                <div className="flex justify-content-start  align-items-center">
                  <ClassetDropdown
                    width={"25vw"}
                    height={"48px"}
                    options={dateRangeOptions}
                    value={this.state.dateRangeType}
                    onChange={(e) => {
                      this.setState({
                        dateRangeType: e.target.value,
                        startDate: null,
                        endDate: null
                      }, this.applyFilters);
                    }}
                    style={{ border: '10px solid #E6E8EA', }}
                    placeholder={(
                      <div className="flex justify-content-start  align-items-center">
                        <span className=''>Select Range</span>
                      </div>
                    )}
                  />

                </div>
              </div>

            </div>
            <div className="flex justify-content-between">

              <div className="flex order-0 gap-5">
                {this.state.dateRangeType == 8 &&
                  <>
                    <div className="col-6">
                      <label className='label'>From Date</label>
                      <ClassetCalendar
                        calendarMode="single"
                        className="text-xl"
                        width={"25vw"}
                        height={"48px"}
                        value={this.state.startDate}
                        placeholder="Select From Date"
                        onChange={(e) => {
                          const selectedStartDate = e.value;
                          this.setState({ startDate: selectedStartDate }, () => {
                            if (this.state.endDate && moment(this.state.endDate).isBefore(selectedStartDate)) {
                              this.setState({ endDate: null });
                            }
                            if (this.state.startDate && this.state.endDate) {
                              this.applyFilters();
                            }
                          });
                        }}
                      />
                    </div>
                    <div className="col-6">
                      <label className='label'>To Date</label>
                      <ClassetCalendar
                        calendarMode="single"
                        className="text-xl"
                        width={"25vw"}
                        height={"48px"}
                        value={this.state.endDate}
                        placeholder="Select To Date"
                        onChange={(e) => {
                          const selectedEndDate = e.value;
                          if (!this.state.startDate) {
                            this.toast.show({
                              severity: 'warn',
                              summary: 'Warning',
                              detail: 'Please select a start date first',
                              life: 3000
                            });
                            return;
                          }
                          if (moment(selectedEndDate).isBefore(this.state.startDate)) {
                            this.toast.show({
                              severity: 'warn',
                              summary: 'Warning',
                              detail: "End date cannot be earlier than start date.",
                              life: 3000
                            });
                            return;
                          }
                          // Only update state if validation passes
                          if (this.state.startDate && selectedEndDate) {
                            this.setState({ endDate: selectedEndDate }, () => {
                              this.applyFilters();
                            });
                          }
                        }}
                      />
                    </div>
                  </>
                }
              </div>

              <div className='flex gap-2 order-1 ml-auto mt-5'>
                <Button
                  label="Download Report"
                  onClick={this.downloadExcelReport}
                  style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#F4F5F6", color: "#000", }}
                />
                <Button label="View Analysis" className="p-button-primary"
                  style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#076EFF", color: "#fff", }} />
              </div>
            </div>
          </div>

          <div className='datatable-report-demo mx-2'>
            <DataTable
              value={this.state.feeCollectionReport}
              dataKey="id"
              paginator
              lazy
              responsiveLayout="scroll"
              columnResizeMode="expand"
              resizableColumns
              onPage={this.onPage}
              first={this.state.lazyParams.first}
              last={this.state.totalRecords}
              rows={this.state.lazyParams.rows}
              totalRecords={this.state.totalRecords}
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              globalFilter={this.state.globalFilter}
            >
              <Column filterField="username" field="username" header="Student Id"
                body={(rowData, { rowIndex }) => {
                  return (
                    <p>
                      {rowData?.username?.slice(3)}
                    </p>
                  )
                }} />
              <Column filterField="firstName" field="" header="Student Name"
                body={(rowData, { rowIndex }) => {
                  return (
                    <p>
                      {rowData?.firstName + " " + rowData?.lastName}
                    </p>
                  )
                }}
              />
              <Column filterField="className" field="username" header="Class-Section"
                body={(rowData, { rowIndex }) => {
                  return (
                    <p>
                      {(rowData?.studentClassName || rowData?.className) + "-" + rowData?.sectionName}
                    </p>
                  )
                }} />
              <Column filterField="receiptNo" field="receiptNo" header="Receipt No" />
              <Column filterField="username" field="username" header="Fee Paid"
                body={(rowData, { rowIndex }) => {
                  return (
                    <p>
                      {rowData?.feePaidDetails?.amountPaying || 0}
                    </p>
                  )
                }}
              />
              <Column filterField="username" field="username" header="Fee Type"
                body={(rowData, { rowIndex }) => {
                  return (
                    <p>
                      {rowData?.feePaidDetails?.feeType}
                    </p>
                  )
                }}
              />

              <Column filterField="username" field="username" header="Payment Mode"
                body={(rowData, { rowIndex }) => {
                  return (
                    <p>
                      {rowData?.paymentMode}
                    </p>
                  )
                }}
              />
              <Column

                filterField="username"
                field="username"


                header="Paid Date"

                body={(rowData, { rowIndex }) => {
                  return (
                    <p>
                      {rowData?.receiptDate ? moment(rowData.receiptDate).format('DD/MM/YYYY') : '-'}
                    </p>
                  )
                }}
              />
              <Column
                alignHeader={'center'}
                bodyClassName="text-center"
                header="Actions"
                body={(rowData, { rowIndex }) => {
                  return (
                    <div className="flex justify-content-center">
                      <div className='mx-2'
                        onClick={() => this.setState({ isBulkfeeReceipts: true, receiptInfo: [{ ...rowData, feePaidDetails: [rowData?.feePaidDetails] }] })}
                      >
                        <DownloadIcon width={20} height={20} color={'#000000'} />
                      </div>
                    </div>
                  );
                }}

              ></Column>
            </DataTable>
            {this.state.isBulkfeeReceipts && (
              <BulkFeeReciepts
                receiptData={this.state?.receiptInfo}
                hideFeeReciept={() => {
                  this.setState({
                    isBulkfeeReceipts: false,
                    receiptInfo: []
                  });
                }}
              />
            )}
          </div>
        </div>
        {this.state.isLoading && <LoadingComponent />}
        <Toast ref={(el) => this.toast = el} position="bottom-right" />

      </>

    )
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.boardsData.loading,
  isBranchLoading: state.branchDataLatest.isLoading,
  branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
  branchData:
    (state.branchDataLatest &&
      state.branchDataLatest.data &&
      state.branchDataLatest.data.data.filter((each) => {
        if (each.level == 1) {
          return { ...each };
        }
      })) ||
    [],
  _id: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data._idF,
  userInfo: state.currentUserPerms?.userInfo || {}
});
export default connect(mapStateToProps, {
  getBranchesLatest
})(Authentication(withRouter(FeeCollectionReport)));

